module.exports = __webpack_public_path__ + "img/logo_tinaba.07df49a4.png";